import { OrderByFields } from './types'

export const defaultOrderFields: OrderByFields = ['isUnfinished', 'hasFreeRounds', 'isFavorite']
